import React, { useState } from "react";
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import { Button, FormLabel, IconButton, Stack, TextField } from "@mui/material";
import Api from "../../network/Api";
import Toolbox from "./Toolbox";

const FeedbackButtons = (props: { conversationId: string, messageId: string }) => {

  const [negative, setNegative] = useState<boolean>(false);
  const [comment, setComment] = useState<string>();
  const [sent, setSent] = useState<boolean>(false);

  const updateSentiment = (type: "positive" | "negative", comment?: string) => {
    Api.post(`/conversations/${props.conversationId}/messages/${props.messageId}/feedbacks`, { sentiment: type, comment: comment }).then(() => setSent(true));
    setNegative(false);
  }

  return <>{ !sent && <Stack direction="row" spacing={0} justifyContent="flex-start" alignItems="center" sx={{mt: 1}} className="animate__animated animate__fadeIn">
    <FormLabel sx={{mr: 1}}><small>Was this response helpful?</small></FormLabel>
    <IconButton size="small" onClick={() => updateSentiment("positive")}><ThumbUpOffAltIcon fontSize="small" /></IconButton>
    <IconButton size="small" onClick={() => setNegative(true)}><ThumbDownOffAltIcon fontSize="small" /></IconButton>

    { negative && <FeedbackDialog value={comment} onChange={setComment} onClose={() => setNegative(false)} onSubmit={() => updateSentiment("negative", comment)} /> }
  </Stack> }</>;
}

export const FeedbackDialog = (props: { onClose: () => void, value?: string, onChange?: (value: string) => void, onSubmit: () => void }) => {
  return <Toolbox title="Feedback" maxWidth="sm" onClose={props.onClose}>
    <TextField variant="filled" multiline rows={3} label="Please describe the issue you have experienced" value={props.value} onChange={e => props.onChange && props.onChange(e.currentTarget.value)} />
    <Button variant="outlined" color="secondary" onClick={props.onSubmit}>Submit</Button>
  </Toolbox>
}

export default FeedbackButtons;